import React from 'react'
import { Card } from '@tecsinapse/cortex-react'
import {
  LiaCircleNotchSolid,
  LiaFileAlt,
  LiaFolderOpenSolid
} from 'react-icons/lia'
import { ItemsPorPasta } from '../../../core/types/graphql'

export const ItemsCount = ({
  itemsPorPasta
}: {
  itemsPorPasta: ItemsPorPasta
}) => {
  const { totalFiles, totalFolders, totalItems } = itemsPorPasta
  if (!totalItems || totalItems < 1) return null
  return (
    <Card className={'mb-deca py-mili'}>
      <div className='flex flex-row items-center space-x-2'>
        {totalFiles && totalFiles > 0 ? (
          <>
            <div className='flex flex-row items-center space-x-1'>
              <LiaFileAlt className='text-primary-medium' />
              <p className='text-secondary-medium'>Arquivos: {totalFiles}</p>
            </div>
          </>
        ) : null}
        {totalFolders && totalFolders > 0 ? (
          <>
            <div className='flex flex-row items-center space-x-1'>
              <LiaFolderOpenSolid className='text-primary-medium' />
              <p className='text-secondary-medium'>Pastas: {totalFolders}</p>
            </div>
          </>
        ) : null}
        {totalItems && totalItems > 0 ? (
          <div className='flex flex-row items-center space-x-1'>
            <LiaCircleNotchSolid className='text-primary-medium' />
            <p className='text-secondary-medium'>Total: {totalItems}</p>
          </div>
        ) : null}
      </div>
    </Card>
  )
}
